import React from "react";
import Breadcrumb from "../../../utils/Breadcrumb";
import { useStandard } from "../../../context/StandardContext";
import DashboardTableView from "../../../components/View/DashboardTableView";
import { Link, useParams } from "react-router-dom";
import DashboardChartView from "../../../components/View/DashboardChartView";
import DashboardCardView from "../../../components/View/DashboardCardView";

function StandardDashboard() {
  const { stdId } = useParams();
  const { standardName } = useStandard();
  return (
    <div className=" w-[92%] h-full mx-auto">
      <div className=" flex justify-start items-center gap-x-6 mb-1 pt-1">
        <Breadcrumb
          items={[
            {
              name: "Standard",
            },
            {
              name: standardName,
            },
            {
              name: "Dashboard",
            },
          ]}
        />
        <Link
          to="/main/progress"
          className="text-primary border border-primary px-3 py-[2px] text-[12px] font-medium rounded-md flex items-center"
        >
          View Progress
        </Link>
      </div>
      <div className="w-[100%] h-[calc(100vh-115px)] p-4 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)] rounded-lg overflow-y-auto">
        <div className=" w-full h-full grid grid-cols-12 grid-rows-6 gap-4">
          <div className="col-span-8 row-span-6">
            <div className=" w-full h-full grid grid-cols-12 grid-rows-6 gap-4">
              <div className="col-span-3 row-span-4 ">
                <DashboardChartView
                  title="Implementation Checklist"
                  path={`/standard/${stdId}/activity/implementation-checklist`}
                  url={`/DashBoard/standard/${stdId}/implementation/`}
                />
              </div>
              <div className="col-span-3 row-span-4 col-start-4 ">
                <DashboardChartView
                  title="Internal Audit Checklist"
                  path={`/standard/${stdId}/activity/internal-audit-checklist`}
                  url={`/DashBoard/standard/${stdId}/internal_audit/`}
                />
              </div>
              <div className="col-span-3 row-span-4 col-start-7">
                <DashboardChartView
                  title="Maintenance"
                  path={`/standard/${stdId}/activity/maintenance`}
                  url={`/DashBoard/standard/${stdId}/maintenance/`}
                />
              </div>
              <div className="col-span-3 row-span-4 col-start-10">
                <DashboardChartView
                  title="Master List of Documents"
                  path={`/standard/${stdId}/activity/master-list-of-documents`}
                  url={`/DashBoard/standard/${stdId}/master_list_of_document/`}
                />
              </div>
              <div className="col-span-4 row-span-2 row-start-5">
                <DashboardCardView
                  title="Training Calendar"
                  path={`/standard/${stdId}/information/training-calendar`}
                  url={`/DashBoard/standard/${stdId}/training-calender/`}
                />
              </div>
              <div className="col-span-4 row-span-2 col-start-5 row-start-5">
                <DashboardCardView
                  title="Security Incident"
                  path={`/standard/${stdId}/information/security-incident`}
                  url={`/DashBoard/standard/${stdId}/security-incident/`}
                />
              </div>
              <div className="col-span-4 row-span-2 col-start-9 row-start-5">
                <DashboardCardView
                  title="Total Vendor"
                  path={`/standard/${stdId}/information/vendor-management`}
                  url={`/DashBoard/standard/${stdId}/vendor/`}
                  cardName="vendor"
                />
              </div>
            </div>
          </div>
          <div className="col-span-4 row-span-3 col-start-9 ">
            <DashboardTableView
              url={`/DashBoard/standard/${stdId}/audit-schedule/`}
              title="Audit Schedule"
              link={`/standard/${stdId}/activity/audit-schedule`}
            />
          </div>
          <div className="col-span-4 row-span-3 col-start-9 row-start-4">
            <DashboardTableView
              url={`/DashBoard/standard/${stdId}/mom/`}
              title="CISO / MRM Meeting MoM"
              link={`/standard/${stdId}/activity/ciso-mom`}

            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StandardDashboard;
